/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { PermissionFromJSON, } from '../models';
/**
 *
 */
var UserAuthorityRestControllerApi = /** @class */ (function (_super) {
    __extends(UserAuthorityRestControllerApi, _super);
    function UserAuthorityRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get context organisation id.  User must be authenticated to access to this endpoint
     * Get context organisation id.
     */
    UserAuthorityRestControllerApi.prototype.getContextOrganisationIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/authority/contextOrganisation",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.TextApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get context organisation id.  User must be authenticated to access to this endpoint
     * Get context organisation id.
     */
    UserAuthorityRestControllerApi.prototype.getContextOrganisationId = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getContextOrganisationIdRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get organisation id of the user, which the user belongs to.  User must be authenticated to access to this endpoint
     * Get organisation id of the user, which the user belongs to.
     */
    UserAuthorityRestControllerApi.prototype.getUsersOrganisationIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/authority/organisation",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.TextApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get organisation id of the user, which the user belongs to.  User must be authenticated to access to this endpoint
     * Get organisation id of the user, which the user belongs to.
     */
    UserAuthorityRestControllerApi.prototype.getUsersOrganisationId = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUsersOrganisationIdRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get accessible resources for given permission of the currently authenticated user in given context organisation.  User must be authenticated to access to this endpoint
     * Get accessible resources for given permission of the currently authenticated user in given context organisation.
     */
    UserAuthorityRestControllerApi.prototype.resolveAccessibleResourcesForCurrentUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.permission !== undefined) {
                            queryParameters['permission'] = requestParameters.permission;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/authority/resources",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get accessible resources for given permission of the currently authenticated user in given context organisation.  User must be authenticated to access to this endpoint
     * Get accessible resources for given permission of the currently authenticated user in given context organisation.
     */
    UserAuthorityRestControllerApi.prototype.resolveAccessibleResourcesForCurrentUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resolveAccessibleResourcesForCurrentUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get resource type and permission map. The map represents accessible resources for each resource type and permission of the currently authenticated user in given context organisation.  User must be authenticated to access to this endpoint
     * Get resource type and permission map.
     */
    UserAuthorityRestControllerApi.prototype.resolvePermissionTreeForCurrentUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/authority/permissionsMap",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get resource type and permission map. The map represents accessible resources for each resource type and permission of the currently authenticated user in given context organisation.  User must be authenticated to access to this endpoint
     * Get resource type and permission map.
     */
    UserAuthorityRestControllerApi.prototype.resolvePermissionTreeForCurrentUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resolvePermissionTreeForCurrentUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List granted permissions of current user  User must be authenticated to access to this endpoint
     * List granted permissions of current user  User must be authenticated to access to this endpoint
     */
    UserAuthorityRestControllerApi.prototype.resolvePermissionsForCurrentUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/authority/permissions",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(PermissionFromJSON); })];
                }
            });
        });
    };
    /**
     * List granted permissions of current user  User must be authenticated to access to this endpoint
     * List granted permissions of current user  User must be authenticated to access to this endpoint
     */
    UserAuthorityRestControllerApi.prototype.resolvePermissionsForCurrentUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resolvePermissionsForCurrentUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return UserAuthorityRestControllerApi;
}(runtime.BaseAPI));
export { UserAuthorityRestControllerApi };
/**
    * @export
    * @enum {string}
    */
export var ResolveAccessibleResourcesForCurrentUserPermissionEnum;
(function (ResolveAccessibleResourcesForCurrentUserPermissionEnum) {
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["AccessGrant"] = "ACCESS_GRANT";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["Any"] = "ANY";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["ApiDocs"] = "API_DOCS";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["Campaign"] = "CAMPAIGN";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["Content"] = "CONTENT";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["ContentBundle"] = "CONTENT_BUNDLE";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["Location"] = "LOCATION";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["Network"] = "NETWORK";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["Organisation"] = "ORGANISATION";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["Player"] = "PLAYER";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["Role"] = "ROLE";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["System"] = "SYSTEM";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["Tag"] = "TAG";
    ResolveAccessibleResourcesForCurrentUserPermissionEnum["User"] = "USER";
})(ResolveAccessibleResourcesForCurrentUserPermissionEnum || (ResolveAccessibleResourcesForCurrentUserPermissionEnum = {}));
